import { render } from "./MonthChart.vue?vue&type=template&id=4b4a9ffa"
import script from "./MonthChart.vue?vue&type=script&lang=js"
export * from "./MonthChart.vue?vue&type=script&lang=js"

import "./MonthChart.vue?vue&type=style&index=0&id=4b4a9ffa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__